import { animate, style, transition, trigger, AUTO_STYLE } from '@angular/animations';

export const enterAnimation = trigger('enterAnimation', [
  transition(':enter', [
    style({opacity: 0}),
    animate('300ms', style({opacity: 1}))
  ]),
  transition(':leave', [
    style({opacity: 1}),
    animate('300ms', style({opacity: 0}))
  ])
]);

export const collapseAnimation = trigger('collapseAnimation', [
  transition(':enter', [
    style({visibility: 'hidden', height: 0, overflow: 'hidden', transform: 'rotateX(-90deg)'}),
    animate('300ms', style({visibility: AUTO_STYLE, height: AUTO_STYLE, transform: 'rotateX(0)'}))
  ]),
  transition(':leave', [
    style({visibility: 1, overflow: 'hidden'}),
    animate('300ms', style({visibility: 'hidden', height: 0, transform: 'rotateX(-90deg)'}))
  ])
]);